
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create a polyfill fallback for any missing methods that might cause issues on mobile
if (!Element.prototype.matches) {
  // Use a type assertion to fix the TypeScript error
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector || 
                             (Element.prototype as any).webkitMatchesSelector;
}

// Add error handling for render process
const renderApp = () => {
  try {
    // Create root with null check
    const rootElement = document.getElementById("root");
    if (!rootElement) throw new Error("Failed to find the root element");

    // Use createRoot (React 18)
    const root = createRoot(rootElement);
    root.render(<App />);
  } catch (error) {
    console.error("Failed to render the application:", error);
    
    // Attempt recovery by showing a simple error message
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: sans-serif;">
          <h2>Something went wrong</h2>
          <p>We're sorry, but the application couldn't be loaded. Please try refreshing the page.</p>
          <button onclick="window.location.reload()" style="padding: 8px 16px; margin-top: 16px; background: #4f46e5; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Reload App
          </button>
        </div>
      `;
    }
  }
};

// Register a global error handler
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Prevent the browser from showing its own error dialog
  event.preventDefault();
  return true;
});

// Initialize the app with a small delay to ensure DOM is fully loaded
// This helps with Chrome on Android initial rendering
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(renderApp, 10));
} else {
  setTimeout(renderApp, 10);
}
